/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { filterListStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterList";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

filterListStyles.wrapper = {
    css: css`
        background: ${getColor("common.background")};
        border: 1px solid ${getColor("common.ui12")};
        border-radius: 6px 6px 0 0;
        overflow: hidden;
    `,
};

filterListStyles.filterText = {
    variant: "h6",
    lineHeight: "20px",
    color: "text.inverse",
    css: css`
        margin-bottom: 0;
        background: ${getColor("common.ui1")};
        padding: 10px 15px;
    `,
};

filterListStyles.filterTag = {
    typographyProps: {
        ellipsis: true,
    },
    css: css`
        ${getProp("theme.tag.defaultProps.css")};
        max-width: 210px;
    `,
};

filterListStyles.clearAllLink = {
    css: css`
        padding-bottom: 0;
    `,
};

(filterListStyles as any).tagsWrapper = {
    css: css`
        padding: 13px 13px 12px;
        display: flex;
        flex-flow: row wrap;
    `,
};

(filterListStyles as any).clearAllWrapper = {
    css: css`
        padding: 0 15px 15px;
        line-height: 14px;
    `,
};
